module.exports = __webpack_public_path__ + "img/logo-call-2.32d57f15.svg";